import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const bonuses = [{
  img: 'https://cdn.magicpatterns.com/uploads/s4RzZZMuhsGQojF6N6GZN4/Bono_1.png',
  label: 'BONO #1',
  title: 'Emergencias Emocionales en la Adolescencia',
  desc: 'Guía de acción rápida para los momentos más difíciles.',
  value: '$16'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/pfraPYWpm5jadMB8XQtPVa/Bono_2.png',
  label: 'BONO #2',
  title: 'Amor Propio y Salud Mental en la Adolescencia',
  desc: 'Cómo cultivar la autoestima saludable de tu hijo.',
  value: '$16'
}];
const includes = [{
  text: 'Guía Principal: Frases listas para conversaciones difíciles (45 páginas)',
  bold: 'Guía Principal:'
}, {
  text: 'Formato PDF · Compatible con iPad, iPhone, tablet y PC',
  bold: null
}, {
  text: 'Ejercicios prácticos imprimibles en cada capítulo',
  bold: null
}, {
  text: 'Acceso inmediato tras el pago',
  bold: null
}];
export function PriceSection() {
  return <section id="precio" className="py-24 px-5 bg-[#FAFAF7] text-center" data-id="element-204">
      <div className="max-w-5xl mx-auto" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-206">
          <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-4" data-id="element-207">
            Inversión en tu familia
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A2744] mb-4" data-id="element-208">
            Si sientes que perdiste la conexión con tu hijo, esta guía te da un
            plan claro.
          </h2>

          <p className="text-lg text-[#718096] max-w-xl mx-auto mb-12" data-id="element-209">
            Sin suscripciones. Sin renovaciones. Tuyo para siempre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white border-2 border-[#E2E8F0] rounded-3xl p-10 md:p-12 max-w-lg mx-auto shadow-[0_20px_60px_rgba(0,0,0,0.08)] relative overflow-hidden" data-id="element-210">
          <div className="absolute top-5 -right-7 bg-[#E53E3E] text-white text-xs font-bold tracking-wide px-10 py-2 rotate-[35deg]" data-id="element-211">
            🔥 MÁS VENDIDO
          </div>

          <h3 className="text-2xl font-bold text-[#1A2744] mb-1" data-id="element-212">
            Guia Completo Adolescencia Sin Miedo
          </h3>

          <ul className="text-left space-y-3 mb-6" data-id="element-213">
            {includes.map((item, index) => <li key={index} className="flex items-center gap-3 text-sm text-[#4A5568] py-3 border-b border-[#F0F4F0]" data-id="element-214">
                <span className="text-[#38A169] text-lg flex-shrink-0" data-id="element-215">✅</span>
                <span data-id="element-216">
                  {item.bold && <strong data-id="element-217">{item.bold}</strong>}{' '}
                  {item.text.replace(item.bold || '', '')}
                </span>
              </li>)}
          </ul>

          {/* Bonos incluidos visibles en la tarjeta de precio */}
          <div className="bg-gradient-to-br from-[#FFF8EC] to-[#FFF1D6] border-2 border-dashed border-[#F4A535] rounded-2xl p-5 mb-8 text-left" data-id="element-218">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-219">
              <GiftIcon className="w-4 h-4 text-[#B5701A]" data-id="element-220" />
              <span className="text-[11px] font-bold tracking-[2px] uppercase text-[#B5701A]" data-id="element-221">
                + 2 Bonos Gratis Incluidos Hoy
              </span>
            </div>
            <ul className="space-y-3" data-id="element-222">
              {bonuses.map((b, i) => <li key={i} className="flex items-center gap-3 bg-white rounded-xl p-3 border border-[#F4A535]/30" data-id="element-223">
                  <img src={b.img} alt={b.title} className="w-14 h-14 object-contain flex-shrink-0 drop-shadow-md" data-id="element-224" />
                  <div className="flex-1 min-w-0" data-id="element-225">
                    <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-226">
                      <span className="text-[10px] font-extrabold tracking-wide text-[#B5701A] bg-[#F4A535]/20 px-2 py-0.5 rounded" data-id="element-227">
                        {b.label}
                      </span>
                      <span className="text-[10px] font-bold text-[#A0AEC0] line-through" data-id="element-228">
                        {b.value}
                      </span>
                      <span className="text-[10px] font-extrabold text-[#38A169]" data-id="element-229">
                        GRATIS
                      </span>
                    </div>
                    <p className="text-xs font-bold text-[#1A2744] leading-tight mb-0.5" data-id="element-230">
                      {b.title}
                    </p>
                    <p className="text-[11px] text-[#718096] leading-snug" data-id="element-231">
                      {b.desc}
                    </p>
                  </div>
                </li>)}
            </ul>
            <p className="text-center text-xs font-bold text-[#B5701A] mt-3" data-id="element-232">
              Valor extra:{' '}
              <span className="line-through text-[#A0AEC0]" data-id="element-233">$32</span> →{' '}
              <span className="text-[#38A169]" data-id="element-234">$0</span> hoy
            </p>
          </div>

          <div id="precio-cta" className="mb-1" data-id="element-235">
            <span className="inline-block bg-[#E53E3E] text-white text-sm font-bold tracking-wide px-5 py-2 rounded-full mb-4" data-id="element-236">
              🔥 60% DE DESCUENTO
            </span>
            <p className="text-base text-[#A0AEC0] line-through mb-1" data-id="element-237">
              Valor total: $19.99 USD
            </p>
            <div className="text-6xl md:text-7xl font-black text-[#1A2744] leading-none mb-1" data-id="element-238">
              <sup className="text-3xl align-top mt-3 inline-block" data-id="element-239">$</sup>7
              <sup className="text-3xl align-top mt-3 inline-block" data-id="element-240">.99</sup>
            </div>
          </div>
          <p className="text-sm text-[#A0AEC0] mb-8" data-id="element-241">
            USD · Pago único · Sin sorpresas
          </p>

          <a href="https://cuidodemisalud.com/cart/47714670411963:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#F4A535] to-[#E8851A] text-[#1A2744] text-xl font-extrabold px-10 py-5 rounded-full shadow-[0_8px_25px_rgba(244,165,53,0.4)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_35px_rgba(244,165,53,0.5)] mb-5" data-id="element-242">
            🚀 Descargar la guía ahora
          </a>

          <div className="flex justify-center gap-5 flex-wrap text-xs text-[#A0AEC0]" data-id="element-243">
            <span className="flex items-center gap-1" data-id="element-244">🔒 Pago 100% Seguro</span>
            <span className="flex items-center gap-1" data-id="element-245">📱 Acceso Inmediato</span>
            <span className="flex items-center gap-1" data-id="element-246">💰 Garantía 7 Días</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-lg mx-auto mt-10 bg-white rounded-2xl p-8 border-2 border-dashed border-[#38A169] text-center" data-id="element-247">
          <div className="text-5xl mb-3" data-id="element-248">🛡️</div>
          <h3 className="text-[#38A169] font-bold text-lg mb-3" data-id="element-249">
            Garantía Total 7 Días
          </h3>
          <p className="text-sm text-[#718096]" data-id="element-250">
            Si en los próximos 7 días sientes que esta guía no era lo que
            necesitabas, te devolvemos el 100% de tu dinero. Sin preguntas. Sin
            complicaciones. Así de seguros estamos de lo que tienes en tus
            manos.
          </p>
        </motion.div>
      </div>
    </section>;
}